import React, { useContext, useEffect, useState } from 'react';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import { FindInPage, Mail, Notifications, Search, CheckCircleOutline, HighlightOffOutlined, VisibilityOff, Visibility } from '@material-ui/icons';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import MaterialTable from 'material-table';
import { centeredCell } from '../../constants/StyleConstants';
import NotificationDetailsModal from './NotificationDetailsModal/NotificationDetailsModal';
import { LoginContext } from '../../contexts/LoginContext';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import FileDownloaderAcerBrag from '../../components/UI/FileDownloaderAcerBrag';
import notificationsAPI from '../../services/NotificationsApi';
import { AppContext } from '../../contexts/AppContext';
import { decodeFile } from '../../utils/MiscellaneousUtils';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import NotificationDetailsConformedDialog from './NotificationDetailsModal/NotificationDetailsConformedDialog';

const useStyles = makeStyles(theme => ({ centeredCell }));

const NotificationsGrid = ({ data, loading, reloadGrid }) => {
  const classes = useStyles();
  const { isSupplier, isAllowedByRole, isAdmin } = useContext(LoginContext);
  const [open, setOpen] = useState(false);
  const [openFiles, setOpenFiles] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [notificationId, setNotificationId] = useState(null);
  const { showError, showSuccess } = useContext(AppContext);
  const [openConformed, setOpenConformed] = useState(false);

  const handleChangeVisubility = (id, status) => {
    return notificationsAPI.changeVisibility({ id, status })
      .then(res => {
        showSuccess("La notificacion se actualizó correctamente");
        reloadGrid();
      })
      .catch(error => showError(error))
  }

  const handleDownloadFile = (id, fileName) => {
    return notificationsAPI
      .getFile(id, fileName)
      .then(res => decodeFile(res, fileName))
      .catch(error => showError('No se pudo descargar el archivo solicitado'));
  };

  useEffect(() => {
    !open &&
      setTimeout(() => {
        setNotificationId(null);
      }, 300);
  }, [open]);

  const colDefs = useGridColDefs([
    { title: 'id', field: 'id', hidden: true },
    { title: 'Área', field: 'area' },
    { title: 'Titulo', field: 'title' },
    {
      title: 'Contenido',
      field: 'content',
      hidden: !isSupplier,
      valueRender: (value) => (
        <Tooltip title={value} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <span style={{ display: 'inline-block', maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {value}
          </span>
        </Tooltip>
      )
    },
    { title: 'Fecha', field: 'date', valueType: 'date' },
    {
      title: 'Adjuntos',
      field: 'fileNames',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip title={value ? 'Ver adjuntos' : 'No se encontraron adjuntos'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <span>
            <IconButton
              disabled={!value}
              aria-label="visualizar"
              size="small"
              color="primary"
              onClick={() => {
                if (isAllowedByRole()) {
                  setFileNames(value);
                  setNotificationId(rowData.id);
                  setOpenFiles(true);
                }
              }}>
              <FindInPage />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Tipo de notificación',
      field: 'mail',
      sorting: false,
      hidden: isSupplier,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <div className={classes.centeredCell}>
          {rowData.email && (
            <Tooltip title="mail" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <Mail color="primary" />
            </Tooltip>
          )}
          {rowData.popup && (
            <Tooltip title="popup" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <Notifications color="primary" />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: 'Conformidad requerida',
      field: 'conformidadRequerida',
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip title="popup" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          {rowData.conformidadRequerida ? <CheckCircleOutline color="primary" /> : <HighlightOffOutlined color="secondary" />}
        </Tooltip>
      ),
    },
    {
      title: 'Activa',
      field: 'activo',
      hidden: isSupplier,
    },
    {
      title: 'Ver detalle',
      field: 'actions',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <div className={classes.centeredCell}>
          <Tooltip title={'Consultar'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <IconButton
              aria-label="visualizar"
              size="small"
              color="primary"
              onClick={e => {
                setNotificationId(rowData.id);
                setOpen(true);
              }}>
              <Search />
            </IconButton>
          </Tooltip>
          {!isSupplier ? rowData.activo == "Si" ?
            <Tooltip title={'Remover'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <IconButton
                aria-label="remover"
                size="small"
                color="primary"
                onClick={e => {
                  handleChangeVisubility(rowData.id, false);
                }}>
                <VisibilityOff />
              </IconButton>
            </Tooltip>
            : <Tooltip title={'Activar'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <IconButton
                aria-label="activar"
                size="small"
                color="primary"
                onClick={e => {
                  handleChangeVisubility(rowData.id, true);
                }}>
                <Visibility />
              </IconButton>
            </Tooltip>
            : ""}


          {isAdmin && rowData.conformidadRequerida && (
            <Tooltip title={'ver conformados'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <IconButton
                aria-label="ver conformados"
                size="small"
                color="primary"
                onClick={e => {
                  setNotificationId(rowData.id);
                  setOpenConformed(true);
                }}>
                <ManageSearchIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
  ]);

  return (
    <>
      <DialogAcerBrag open={openFiles} setOpen={setOpenFiles} title="Adjuntos">
        <FileDownloaderAcerBrag data={fileNames} action={fileName => handleDownloadFile(notificationId, fileName)} />
      </DialogAcerBrag>
      <NotificationDetailsModal open={open} setOpen={setOpen} notificationId={notificationId} reloadGrid={reloadGrid} />
      <MaterialTable {...defaultGridOptions} columns={colDefs} data={data} isLoading={loading} />
      <DialogAcerBrag open={openConformed} setOpen={setOpenConformed} title="Bandeja de confirmaciones de adhesión">
        <NotificationDetailsConformedDialog notificationId={notificationId} />
      </DialogAcerBrag>

    </>
  );
};

export default NotificationsGrid;
